<template>
    <span v-if="displayBagdes" class="badge-container" @click.prevent="onClick">
        <span v-if="label!=null" :class="['badge','name']">
            {{ getLabelName }}
        </span>
    </span>
    <input v-else type="text" readonly placeholder="Label" :value="value"  :class="!!getLabelName.length ? 'is-empty' : ''" @click.prevent="onClick"/>
</template>

<script>
    import {safeObj} from "@/utils/safeObj";

    export default {
        name: "LabelTextInput",
        props: {
            label: { type: [Object, Array] },
            labels: { type: [Array, String] },
            displayBagdes: { type:Boolean, default:false }
        },
        computed: {
            value() {
                if (this.labels) {
                    const labelsToString = this.labels.map(item => {
                        return item.name;
                    })

                    return labelsToString.join(', ');
                }

                return this.getLabelName;
            },
            getLabelName() {
                // check if is Object or Array
                if(safeObj(this.label) || this.label){
                    if( Array.isArray(this.label) ){
                        return this.label[0].name
                    }
                    // return name properties of object
                    return this.label.name
                }
                // if it's not object or array, return empty string
                return ''
            }
        },
        methods: {
            onClick(event) { this.$emit("click", event); }
        }
    }
</script>

<style lang="scss" scoped>
    .badge-container {
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #d2d2d2;
        height: 30px;
        display: block;
    }

    .badge-container:hover {
        border-bottom: 1px solid #18B9E7;
        cursor: pointer;
    }

    .badge-container .badge {
        background: #18B9E7;
        border-radius: 100px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        padding: 5px 10px;
        color: white;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin: 0 5px;
    }

    .badge-container .badge.hidden {
        background: #d2d2d2;
    }

    .badge-container .badge .name,
    .badge-container .badge.name
    {
        width: 100%;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 1em;
    }

    input[type=text] {
        text-overflow: ellipsis;

        .table-footer &,
        .table-footer &::placeholder {
            color: #fff;
            font-weight: 400;
        }
    }

    .placeholder {
        color:#d2d2d2;

        .table-footer & {
            color: #fff;
        }
    }
</style>
